import { render, staticRenderFns } from "./CustomTwoColumnTable.vue?vue&type=template&id=b1a52d5a&scoped=true&"
import script from "./CustomTwoColumnTable.vue?vue&type=script&lang=js&"
export * from "./CustomTwoColumnTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomTwoColumnTable.vue?vue&type=style&index=0&id=b1a52d5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a52d5a",
  null
  
)

export default component.exports